import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { getFormattedCart } from "@/utils/functions";
import { useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function OrgPayment({
    plate,
    disabled,
}: {
    plate: string;
    disabled?: boolean;
}) {
    const navigate = useNavigate();
    const user = useSelector((state: ReducersTypes) => state.userReducer);

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => setCollapsed(collapsed => !collapsed);

    const {
        total,
        filteredItems,
    } = getFormattedCart({
        // @ts-expect-error reducer type
        debts: user?.debts,
        // @ts-expect-error reducer type
        cart: user?.cart,
    });
    
    return (
        <div className="fixed bottom-0 z-10 bg-white w-[calc(480px)] max-w-[calc(96%)] shadow-md rounded-t-xl p-3">
            {collapsed && <div className="mb-1 overflow-auto max-h-[calc(243px)]">
                <p className="text-lg mb-1">Placa: <span className="uppercase">{plate}</span></p>
                {filteredItems?.map(((item, index) => (
                    <div key={index} className="flex w-full justify-between">
                        <p className="text-sm">{item?.original?.nmPraca}</p>
                        <p className="text-sm">R$ {item.price}</p>
                    </div>
                )))}
            </div>}
            <div className="w-full flex justify-between items-center">
                <p className="text-lg">Total a pagar:</p>
                <button onClick={toggleCollapsed}>
                    <img
                        src={collapsed ? "/arrow-bottom.png" : "/arrow-top.png"}
                        width={32}
                        height={32}
                        alt={collapsed ? "Retrair total" : "Expandir total"}
                    />
                </button>
            </div>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <div className="w-full flex justify-between items-center">
                <p className="text-xl flex items-center"><span className="text-base">R$</span> {total?.toFixed(2)?.toString().replace(/\./g, ',')}</p>
                <button
                    disabled={disabled || total === 0}
                    className={`${disabled || total === 0 ? "bg-gray-300" : "bg-black"} text-white p-2 rounded-lg w-28`}
                    onClick={total > 0 && !disabled ? () => navigate('/checkout') : () => null}>
                    Continuar
                </button>
            </div>
        </div>
    );
}
